import Section from './Section';
import Utils from "../Services/Utils";

class SectionList {
  constructor(item) {
    this.order = item.order || [];
    this.items = item.items || null;
  }

  static parse = async (sections, disabled, chargeCodes) => {
    const order = sections.order || [];
    const items = {};
    const sectionsItems = (!Utils.isNull(sections) && !Utils.isNull(sections.items)) ? Object.values(sections.items) : sections;
    const fieldsIdLabelDict = this._getAllFieldsIdLabelDict(sectionsItems);
    const fieldsIdOptionsDict = this._getAllFieldsIdOptionsDict(sectionsItems);
    if (!sectionsItems.length) {
      const section = new Section({ id: 'sectiondividerInitial', label: 'Dynamic Form', component:'sectionDivider' });
      order.push(section.id);
      items[section.id] = section;
    } else if (!order.length) {
      for (const section of sectionsItems) {
        order.push(section.id);
        items[section.id] = await Section.parse(section, fieldsIdLabelDict, fieldsIdOptionsDict, disabled, chargeCodes);
      }
    } else {
      for (const sectionId of order) {
        items[sectionId] = await Section.parse(sections.items[sectionId], fieldsIdLabelDict, fieldsIdOptionsDict, disabled, chargeCodes);
      }
    }

    return new SectionList({
        order: order,
        items: items,
      },
    );
  };

  static _getAllFieldsIdLabelDict(sections) {
    const dict = {};
    for (const section of sections) {
      const children = (!Utils.isNull(section.fields) && !Utils.isNull(section.fields.items)) ? Object.values(section.fields.items) : section.children;
      for (const field of children) {
        dict[field.id] = field.label;
      }
    }
    return dict;
  }


  static _getAllFieldsIdOptionsDict(sections) {
    const dict = {};
    for (const section of sections) {
      const children = (!Utils.isNull(section.fields) && !Utils.isNull(section.fields.items)) ? Object.values(section.fields.items) : section.children;
      for (const field of children) {
        dict[field.id] = field.options;
      }
    }
    return dict;
  }

  serialize = (builder) => {
    const arr = [];
    for (const [index, item] of this.order.entries()) {
      this.items[item].changeValue('index', index);
      const section = this.items[item].serialize(builder);
      arr.push(section);
    }
    return arr;
  };

  serializeAsync = async (builder) => {
    const arr = [];
    for (const [index, item] of this.order.entries()) {
      this.items[item].changeValue('index', index);
      const section = await this.items[item].serializeAsync(builder);
      arr.push(section);
    }
    return arr;
  };

  changeOrder(source, destination) {
    const item = this.order.splice(source, 1)[0];
    this.order.splice(destination, 0, item);
  }

  addSection(index, section) {
   this.order.splice(index, 0, section.id);
   this.items[section.id] = section;
  }

  removeSection(index) {
    const fieldName = this.order.splice(index, 1)[0];
    const item = this.items[fieldName];
    delete this.items[fieldName];
    return item;
  }

}

export default SectionList;
